import {useEffect, useState} from "preact/compat";

export const useSidebarCart = props => {
    // Destructured controller props
    const {sidebarCartData} = props;

    // State to control the loader state while data is being fetched or posted
    const [isLoading, setIsLoading] = useState(false);

    // Procedure to handle the isLoading state
    const handleCartLoader = (
        state = undefined
    ) => {
        setIsLoading(prevState => {
            return typeof state !== "undefined" ? state : prevState;
        });
    }

    // A workaround, maybe? Perhaps...
    const manuallyRemoveOverflow = () => {
        // Reactivates the body overflow
        document.body.classList.remove("overflow-deactivate");
    }

    // Effect that will be fired immediately when the component is opened to fetch data
    useEffect(() => {
        if (sidebarCartData.isOpen) {
            // Deactivates the body overflow
            document.body.classList.add("overflow-deactivate");

            return;
        }

        // Reactivates the body overflow
        manuallyRemoveOverflow();
    }, [sidebarCartData.isOpen]);

    return {
        isLoading,
        handleCartLoader,
        manuallyRemoveOverflow,
    }
}
